import { tabsAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  tabsAnatomy.keys
);

export const tabsRecipe = defineMultiStyleConfig({
  baseStyle: {
    tab: {
      color: 'primary.300',
      _selected: {
        color: 'primary.500',
        borderBottomColor: 'primary.500',
        borderBottomWidth: '2px',
      },
    },
  },
});
